import { createSelector } from 'reselect';

import { State } from '@src/store/types';

const authenticationSelector = (state: State) => state.authentication;

export const tokensSelector = createSelector(
  authenticationSelector,
  ({
    accessToken,
    refreshToken,
    userID,
    region,
    setupComplete,
    labelsFilled,
  }) => ({
    accessToken,
    refreshToken,
    userID,
    region,
    setupComplete,
    labelsFilled,
  })
);

export const profileSelector = createSelector(
  authenticationSelector,
  ({ profile }) => profile
);

export const primeSelector = createSelector(
  authenticationSelector,
  ({ prime }) => prime
);
export const allSelector = createSelector(
  authenticationSelector,
  ({ allAccess }) => allAccess
);
export const immigrationSelector = createSelector(
  authenticationSelector,
  ({ immigration }) => immigration
);
export const hasPrimeSelector = createSelector(
  primeSelector,
  (prime) => !!prime?.hasAccess
);
export const hasImmigrationSelector = createSelector(
  immigrationSelector,
  (immigration) => !!immigration?.hasAccess
);

export const setupCompleteSelector = createSelector(
  authenticationSelector,
  ({ setupComplete }) => !!setupComplete
);

export const allAccessSelector = createSelector(
  authenticationSelector,
  ({ allAccess }) => allAccess
);

export const labelsFilledSelector = createSelector(
  authenticationSelector,
  ({ labelsFilled }) => !!labelsFilled
);

export const labelsSelector = createSelector(
  authenticationSelector,
  ({ labels }) => labels
);

export const isAuthenticatedSelector = createSelector(
  authenticationSelector,
  ({ accessToken }) => !!accessToken
);
